import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { AssigneeDto } from '../../../commonTypes/project.types';
import { ICallback } from '../../../commonTypes/hook.types';
import { useTranslation } from '../../useTranslation';

const useHttpPostProjectAssignees = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (id: string, body: { assignees: AssigneeDto[] }, callback: ICallback, activateAssignee?: boolean) => {
        const { exec, clearCache, abort } = projectApi.addProjectAssignees({
            params: { id },
            body,
            onSuccess: _ => {
                if (activateAssignee) toastHandler.push('success', t('projects.activateAssigneeTitle'), t('projects.activateAssigneMessage_Success'));
                else toastHandler.push('success', t('projects.addAssigneesTitle'), t('projects.addAssigneesMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
                clearCache();
            },
            onError: _ => {
                if (activateAssignee)
                    toastHandler.push('error', t('projects.activateAssigneeTitle'), t('projects.activateAssigneMessage_FailedNoPesmission'));
                else toastHandler.push('error', t('projects.addAssigneesTitle'), t('projects.addAssigneesMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostProjectAssignees;
